var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"login-dialog"},[_c('div',{staticClass:"login-dialog_box",style:({ height:`${_vm.iHeight}px`})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }